<template>
    <transition ref="transition" :name="transition">
        <div v-show="visible" :class="!!link ? 'cursor-pointer' : '' ">
            <a v-if="link" :href="link" target="_BLANK">
                <img :src="image(slide.upload)" width="100%" :class="home ? 'responsive-banner':''">
            </a>
            <img
                v-else
                :src="image(slide.upload)"
                width="100%" :class="home ? 'responsive-banner':''"
            >
        </div>
    </transition>
</template>

<script>
import image from '../../../mixins/image';

export default {
    name: 'CarouselSlider',
    mixins: [image],
    props: {
        slide: {
            type: Object,
            required: true,
        },
        direction: {
            type: String | null,
            required: true,
        },
        home: {
            type: Boolean,
        },
        slideIndex: {
            type: Number,
            default: 0,
        },
        currentIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            link: this.slide.settings.link,
        };
    },
    computed: {
        transition() {
            if (this.direction) {
                return `slide-${this.direction}`;
            }
            return null;
        },
        visible() {
            return this.slideIndex === this.currentIndex;
        },
    },
};
</script>

<style lang="scss" scoped>

.cursor-pointer {
    cursor: pointer;
}

.slide-right-enter-active {
    animation: slideRightIn 0.8s;
}

.slide-right-leave-active {
    animation: slideRightOut 0.8s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
}

@keyframes slideRightIn {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes slideRightOut {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

.slide-left-enter-active {
    animation: slideLeftIn 0.8s;
}

.slide-left-leave-active {
    animation: slideLeftOut 0.8s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
}

@keyframes slideLeftIn {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes slideLeftOut {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(100%);
    }
}
.responsive-banner{
    object-fit: cover;
    @media screen and (max-width: 1024px) {
        height: 100%;
    }

}
</style>
